export const BANNER_ACTION = Object.freeze({
  ACCEPT_ORDER: "AcceptOrder",
  PROMOTION: "Promotion",
  SKU_DETAILS: "SkuDetails",
  CART: "Cart",
  SEARCH: "Search",
  VIEW: "View",
});
